import React, { Component } from 'react'
import classNames from 'classnames'
import './Field.less'

/**
 * @deprecated This method should not be used - use Fieldset instead
 */
export default class Field extends Component<{
  children: any
  iconRight?: boolean
  stretch?: boolean
}> {
  static defaultProps = {
    iconRight: false,
    stretch: false
  }

  render() {
    const { props } = this
    return (
      <div
        className={classNames('Field', {
          'Field--icon-right': props.iconRight,
          'Field--stretch': props.stretch
        })}
      >
        {props.children}
      </div>
    )
  }
}
